// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

// Import firebase
import { firebaseAuth, usersModel } from '@/firebase/firebase-config'

export const BindUser = {

    /*
	**  Register the mixins
	*/

	mixins: [

        BugsnagService

    ],

    /*
	**  Set up the data
	*/

	data: () => ({

        user: null

    }),

    /*
	**  Methods
    */
    
    methods: {

        bindUserHandler: async function() {

            try {

                this.$bind('user', usersModel.doc(firebaseAuth.currentUser.uid))
                .catch(error => {

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
                
                    this.reportAuthBugsnagError({
                        title: 'Bind to the User from Firestore',
                        errorType: 'Firestore Database',
                        section: 'Events/Users',
                        uid: '7QcraLfOIlW3dv5k3Cas',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Unable to Perform the Query to Bind to the User Document from Firestore',
                    errorType: 'Firestore Database',
                    section: 'Events/Users',
                    uid: 'EjerXFKXjtktBA1TFbKa',
                    error: e
                });

            }

        }

    }

}